import { Noto_Color_Emoji } from "next/font/google"
const NotoColorEmoji = Noto_Color_Emoji({
  weight: "400",
  subsets: ["emoji"],
})

interface FlagIconProps {
  countryCode: string
  size?: number
}

import React from "react"

interface FlagIconProps {
  countryCode: string
  size?: number
}

export const FlagIcon: React.FC<FlagIconProps> = ({ countryCode }) => {
  const supportsNativeEmoji = React.useMemo(() => {
    if (typeof window === "undefined") return true
    const userAgent = window.navigator.userAgent.toLowerCase()
    return /iphone|ipad|ipod|mac os/.test(userAgent)
  }, [])

  const flagEmoji = countryCode.toUpperCase().replace(/./g, char => String.fromCodePoint(char.charCodeAt(0) + 127397))
  if (supportsNativeEmoji) {
    return <span style={{ fontSize: "24px" }}>{flagEmoji}</span>
  } else {
    return (
      <span
        style={{
          fontSize: "18px",
          fontFamily: `${NotoColorEmoji.style.fontFamily}`,
        }}>
        {flagEmoji}
      </span>
    )
  }
}
